import * as troubleApi from '../../api/troubleApi'

const state = {
    NavigationOutput:[],


    // BrandList: [],
    // MobileList: [],
    // TroubleList: [],
    // SKU: "",
    // Price: ""
}

const getters = {

}

const actions = {
    async GetNavigation({ commit }, params) {
        const response = await troubleApi.GetNavigation(params);
        if (response.Status) {
            commit('SetNavigation', response.Data)
        }
    },
    // async GetBrandList({ commit }) {
    //     const response = await troubleApi.GetBrand();
    //     if (response.Status) {
    //         commit('SetBrandList', response.Data)
    //     }
    // },
    // async GetMobileList({ commit }, brandid) {
    //     const response = await troubleApi.GetMobile(brandid);
    //     if (response.Status) {
    //         commit('SetMobileList', response.Data)
    //     }
    // },
    // async GetTroubleList({ commit }, mobileId) {
    //     const response = await troubleApi.GetTrouble(mobileId);
    //     if (response.Status) {
    //         commit('SetTroubleList', response.Data)
    //     }
    // },
    // async GetSku({ commit }, propertys) {
    //     const response = await troubleApi.GetSku(propertys);
    //     if (response.Status) {
    //         commit('SetSku', response.Data.SkuCode)
    //         commit('SetPrice', response.Data.RepairAmount)
    //     } else {
    //         commit('SetSku', "");
    //         commit('SetPrice', "")
    //     }
    // }
}

const mutations = {
    SetNavigation(state, data) {
        state.NavigationOutput = data
    },
    
    // SetBrandList(state, data) {
    //     state.BrandList = data
    // },
    // SetMobileList(state, data) {
    //     state.MobileList = data
    // },
    // SetTroubleList(state, data) {
    //     state.TroubleList = data
    // },
    // SetSku(state, data) {
    //     state.SKU = data
    // },
    // SetPrice(state, data) {
    //     state.Price = data
    // }
}

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/trouble.js